// extracted by mini-css-extract-plugin
export default {"sectionContainer":"NewCustomerPage_sectionContainer__WN7z1","buttons":"NewCustomerPage_buttons__TUmAh"};